function quickView() {
  $('.bc-sf-filter-product-bottom').equalizeHeight();$(window).resize(function(){$('.bc-sf-filter-product-bottom').equalizeHeight()});
  $(".quick-view").each(function () {
    var inlineQuickVIew = $(this).closest('.product-card');
    // console.log(inlineQuickVIew.length);
    // console.log(this);
    
    if (inlineQuickVIew.length > 0 && inlineQuickVIew.find('.qv-add-to-cart.product-single').size() == 0) {
      var product_handle = $(this).data('handle');
      inlineQuickVIew.addClass(product_handle);
      jQuery.getJSON(product_handle + '.js', function (product) {
      }).done(function (product) {
        console.log('inlineQuickVIew'),
        inlineQuickVIew.append(quickATC)
        // console.log(product);
        var product_id = product.id;
        // console.log(product_id);
        var title = product.title;
        var type = product.type;
        var price = 0;
        var original_price = 0;
        var desc = product.description;
        var images = product.images;
        var variants = product.variants;
        var options = product.options;
        var url = '/products/' + product_handle;
        inlineQuickVIew.find('.product_form').attr('data-product', JSON.stringify(product));
        inlineQuickVIew.find('.product_form').attr('data-product-id', product_id);
        inlineQuickVIew.addClass('product-' + product_id);
        // product.media.length
        // console.log(product.media);
        $(options).each(function (i, option) {
          var opt = option.name;
          var selectClass = '.option.' + opt.toLowerCase();
          var variantSwatch = inlineQuickVIew.find('.qv-product-options').data('variant-swatch');
          var variantSwatchImg = inlineQuickVIew.find('.qv-product-options').data('variant-swatchimg');
          var swtchWrap = '';
          var optionHide = '';
          var defultOption = '';
          
          if (opt == 'Title') {
            var defultOption = ' hide';
          }
          if (option.values.length < 2){
            var defultOption = ' lowOption'
          }
          if (variantSwatch == true) {
            var optionHide = ' hide';
            var swtchWrap = '<div data-option-index="' + i + '" id="'+product.id+'-'+opt+'" class="option-selection swatch option-selection-swatches option-selection-' + opt.toLowerCase() + '-swatches' + defultOption +'"></div>';
          }
          inlineQuickVIew.find('.qv-product-options .swatch_options').prepend(swtchWrap);
          inlineQuickVIew.find('.qv-product-options .product-form__controls-group').addClass(defultOption).append('<div class="option-selection option-selection-' + opt.toLowerCase() + optionHide + defultOption + '"><span class="option">' + opt + '</span><select class="single-option-selector option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');

          $(option.values).each(function (i, value) {
            // Color swatched hack
            var select_option = '';
            var swatch_img_name = '';
            var swatchStyle = '';
            if (i == 0) { select_option = "checked='checked'"; }
            if (option.name == 'Color') {
              var swatch_img_name = value;
              swatch_img_name = swatch_img_name.toLowerCase();
              swatch_img_name = swatch_img_name.replace(" ", "-").replace("/", "-");
              swatch_Color = swatch_img_name;
              // console.log(swatch_Color);
              var swatch_assets_img = assetUrl; 
              swatch_img_name = swatch_assets_img.replace('quickview.js', swatch_img_name+'.png');
              // console.log(swatch_img_name);
              if (variantSwatchImg == true) {
                var swatchStyle = 'style="background-color: ' + swatch_Color + ';background-image:url(' + swatch_img_name + ');"';
              } else {
                var swatchStyle = 'style="background-color: ' + swatch_Color + ';"';
              }
            }
            var valueName = value;
            inlineQuickVIew.find('.option-selection-' + opt.toLowerCase() + '-swatches').append('<div class="product-single__swatch__item swatch-element" value="' + value + '" data-value="' + value + '"><input type="radio" ' + select_option + ' class="product-single__swatch__input u-hidden-visually" id='+product_id +'-' + opt + value +' name="' +product_id +'-' + opt + '" value="' + value + '" /><label for='+product_id +'-' + opt + value +' class="product-single__swatch__label"><span class="product-single__swatch__label__graphic" ' + swatchStyle + '>' + valueName + '</span></label></div>');
            inlineQuickVIew.find('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
          });
        });
        // console.log(product.variants.length);
        // console.log(product);
        var availableVariants = '';
        $(product.variants).each(function (i, v) {
          if (v.available == true) {
            inlineQuickVIew.find('.qv-add-button').prop('disabled', false).find('[data-add-to-cart-text]').text('Add to cart');
          } else {
            inlineQuickVIew.find('.qv-add-button').prop('disabled', true).find('[data-add-to-cart-text]').text('Sold Out');
          }            
          if (v.inventory_quantity == 0) {
            inlineQuickVIew.find('.qv-add-button').prop('disabled', true).val('Sold Out');
            inlineQuickVIew.find('.qv-add-to-cart').hide();
            inlineQuickVIew.find('.qv-product-price').text('Sold Out').show();
            return true
          } else {
            availableVariants = v.id;
            price = parseFloat(v.price / 100).toFixed(2);
            original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            
            // console.log('price: '+ theme.Currency.formatMoney(v.price,theme.moneyFormat)+', Orignal Price: '+ theme.Currency.formatMoney(v.compare_at_price,theme.moneyFormat));
            // console.log('Compare at price: ',Shopify.formatMoney(v.price, theme.moneyFormat), 'Compare at price: ',Shopify.formatMoney(v.compare_at_price, theme.moneyFormat));
            if (v.compare_at_price > v.price) {
              inlineQuickVIew.find('.price__pricing-group .price__sale .price-item--sale').text(Shopify.formatMoney(price, theme.moneyFormat));
              inlineQuickVIew.find('.price__pricing-group .price__sale .price-item--regular').text(Shopify.formatMoney(original_price, theme.moneyFormat));
              inlineQuickVIew.find('.product__price dl.price ').addClass('price--on-sale');
              // console.log('sale');
            } else if (v.compare_at_price == null) {
              inlineQuickVIew.find('.price__pricing-group .price__regular .price-item--regular').text(Shopify.formatMoney(price, theme.moneyFormat));
              inlineQuickVIew.find('.product__price dl.price').removeClass('price--on-sale');
              // console.log('Null');
            } else if (v.compare_at_price < v.price) {
              inlineQuickVIew.find('.price__pricing-group .price__regular .price-item--regular').text(Shopify.formatMoney(price, theme.moneyFormat));
              inlineQuickVIew.find('.product__price dl.price').removeClass('price--on-sale');
              // console.log('No sale');
            }
            inlineQuickVIew.find('select.option-1').val(v.option2);
            inlineQuickVIew.find('select.option-2').val(v.option3);
            inlineQuickVIew.find('select.option-0').val(v.option1);
            return false
          }
        });
        var variantsOption = '';
        $(product.variants).each(function (i, variant) {
          // if(variant.id == availableVariants){} else {}
          variantsOption += `<option value="${variant.id}" ${variant.id == availableVariants ? 'selected="selected"' : ''}>${variant.title} - ${Shopify.formatMoney(variant.price)}</option>`;
        });
        inlineQuickVIew.find('.select').html(`<select id="product-select-${product.id}" name="id" style="display: none;">${variantsOption}</select>`)
        // inlineQuickVIew.find().html(); inlineQuickVIew
        if(inlineQuickVIew.find('.option-selection:visible').length < 1){
          inlineQuickVIew.addClass('alloptionHidden');
        }
        // console.log(inlineQuickVIew.find('.option-selection:visible').length);
        inlineQuickVIew.find('.qv-add-to-cart.product-single ~ .qv-add-to-cart.product-single').remove();
        inlineQuickVIew.find('.option-selection.option-selection-size ~ .option-selection.option-selection-size').remove();
        $('.qv-add-to-cart.product-single fieldset .qv-product-options').matchHeight();
        $('.qv-add-to-cart.product-single fieldset .qv-product-options .swatch_options').equalizeHeight();
        $('.product-info .product-title-wrap').matchHeight();

        function toTitleCase(str) {
          var lcStr = str.toLowerCase();
          return lcStr.replace(/(?:^|\s)\w/g, function(match) {
              return match.toUpperCase();
          });
        }
        if(document.querySelectorAll('.collectionAll_tags .color').length > 0){
          var colorName = document.querySelector('.collectionAll_tags .color').textContent;
          colorName = colorName.replace('-',' ')
          colorName = toTitleCase(colorName);
          colorName = colorName;
          // console.log('currentTag: ',colorName); 
          $('input.product-single__swatch__input[value="'+colorName+'"]').trigger('click');
        }
        if(document.querySelectorAll('.collectionAll_tags .size').length > 0){
          var colorName = document.querySelector('.collectionAll_tags .size').textContent;
          colorName = colorName.toUpperCase();
          // console.log('currentTag: ',colorName); 
          $('.single-option-selector.option.size option[value="'+colorName+'"]').closest('select').val(colorName).change();
        }
      });

    }
  });
  $('.product-single__swatch__item').unbind( "click" );
  $(document).on("click", ".product-single__swatch__item", function () {
    var value = $(this).find('input[type=radio]').val(),
    index = $(this).parents('.swatch').data('option-index'),
    targetSelect = $(this).parents('.qv-product-options').find('.product-form__controls-group .option-selection .single-option-selector.option-'+index+'');
    // targetLabel = $(this).closest('.option-selection-color-swatches').find('.option b');
    if (value != '') {
      $(this).siblings('.product-single__swatch__item').find('input[type=radio]').attr('checked', false);
      $(this).find('input[type=radio]').attr('checked', true);
      // console.log('targetSelect: ',targetSelect.val());
      $(targetSelect).val(value).change();
    }
  });

  $(document).on("change", ".qv-product-options .single-option-selector", function () {
    var inlineQuickVIew = $(this).closest('.product-card');
    var formSelector = $(this).closest('.product_form');
    var product = formSelector.data('product');
    var selectedOptions = '';
    var productAvailability = formSelector.find('.product__availability');
    var producText = {
      available: "Available",
      unavailable: "SOLD OUT",
      items: "items",
    };
    selectors = $(this).closest('.product-form__controls-group').find('select');
    $(selectors).each(function (i) {
      if (selectedOptions == '') {
        selectedOptions = $(this).val();
      } else {
        selectedOptions = selectedOptions + ' / ' + $(this).val();
      }
    });
    $(product.variants).each(function (i, v) {
      // console.log(v.inventory_management);
      if(v.title == selectedOptions){
        // VARIANT AVAILABILITY Low stock 
      //  console.log(v);
       price = Shopify.formatMoney(v.price);
       original_price = Shopify.formatMoney(v.compare_at_price);
       //console.log(`Price: ${price}, Original price: ${original_price}, Available: ${v.available}`);
       if(v.available == false) {
         //  sold
        inlineQuickVIew.find('button.btn.qv-add-button').prop('disabled', true).find('[data-add-to-cart-text]').text('Sold Out');
        // inlineQuickVIew.find('button.btn.qv-add-button').hide();
        inlineQuickVIew.find('.product-title-wrap > .price').html('<div class="prod-price"><span class="money" data-product-id="'+product.id+'">Sold Out</span></div>');
        inlineQuickVIew.find('.sale-item').remove();
        // inlineQuickVIew.find('.qv-product-price').text('Sold Out').show();
        return true
       } else if (v.compare_at_price > v.price) {
         inlineQuickVIew.find('button.btn.qv-add-button').prop('disabled', false).find('[data-add-to-cart-text]').text('Add to cart');
         inlineQuickVIew.find('.product-title-wrap > .price').html(`<div class="onsale"><span class="money"><span class="money" data-product-id="${product.id}">${price}</span></span></div><div class="was"><span class="money">${original_price}</span></div>`);
         inlineQuickVIew.find('.sale-item').remove();
         inlineQuickVIew.append('<div class="sale-item icn">Sale</div>');
         //  inlineQuickVIew.find('.product__price dl.price ').addClass('price--on-sale');
          // console.log('sale');
       } else {
        inlineQuickVIew.find('button.btn.qv-add-button').prop('disabled', false).find('[data-add-to-cart-text]').text('Add to cart');
        inlineQuickVIew.find('.product-title-wrap > .price').html('<div class="prod-price"><span class="money">'+price+'</span></div>');
        inlineQuickVIew.find('.sale-item').remove();
       }


        if (v.inventory_management === 'shopify' && window.inventories && window.inventories[product.id]) {
          variantInventoryObject = window.inventories[product.id][v.id];
          var inventory_quantity = variantInventoryObject.quantity;
          var inventory_policy = variantInventoryObject.inventory_policy;
          var incoming = variantInventoryObject.incoming;
          var inventory_threshold = variantInventoryObject.inventory_threshold;
          var showInventory = true;
          var showIncomingInventory = false;
          // console.log('['+product.id+']['+v.id+']');
          if ( inventory_quantity == 0 && inventory_policy == 'continue' ) {
            productAvailability.removeClass('notify_danger').addClass('notify_success').html( producText.available );
          } else if(inventory_policy == 'deny' && inventory_quantity == '0' ){
            productAvailability.addClass('notify_danger').removeClass('notify_success').html( producText.unavailable );
          } else {
            productAvailability.removeClass('notify_danger').addClass('notify_success').html( inventory_quantity + ' ' + producText.items );
          };
        } else {
          productAvailability.removeClass('notify_danger').addClass('notify_success').html( producText.available );
        };
        // console.log(inlineQuickVIew);
       if (v.available == true) {
         inlineQuickVIew.find('.qv-add-button').prop('disabled', false).find('[data-add-to-cart-text]').text('Add to cart');
       } else {
         inlineQuickVIew.find('.qv-add-button').prop('disabled', true).find('[data-add-to-cart-text]').text('Sold Out');
        }
        if(v.featured_image){
          if(inlineQuickVIew.find('.box-ratio').length > 0){
            inlineQuickVIew.find('.reveal > .hidden').addClass('active');
            inlineQuickVIew.find('.reveal > .hidden > .box-ratio img').attr('data-srcset',null).attr('srcset',null,)
            .attr( "src", function() {
              return v.featured_image.src;
            });
          }
          if(inlineQuickVIew.find('.bc-sf-filter-product-item-flip-image').length > 0){
            // console.log(v.featured_image.src);
            inlineQuickVIew.find('.bc-sf-filter-product-item-flip-image').attr('data-srcset',null).attr('srcset',null,)
            .attr( "src", function() {
              return v.featured_image.src;
            }).addClass('active');
          }
       }
      } 
    });
    // console.log('Product false');
  });

  $(document).on("click", ".qv-add-button", function (e) {
    e.preventDefault();
    var formSelector = $(this).closest('.product_form');
    var product = formSelector.data('product');
    // console.log(product);
    var qty = formSelector.find('.qv-quantity').val();
    var selectedOptions = '';
    var var_id = '';
    formSelector.find('select.single-option-selector').each(function (i) {
      if (selectedOptions == '') {
        selectedOptions = $(this).val();
      } else {
        selectedOptions = selectedOptions + ' / ' + $(this).val();
      }
    });
    // console.log(selectedOptions);
    $(product.variants).each(function (i, v) {
      if (v.title == selectedOptions) {
        // console.log(this);
        var_id = v.id;
        processCart(var_id);
        // console.log(var_id);
      }
    });
    function processCart() {
      // console.log('processCart');
      formSelector.find('.qv-add-button span[data-add-to-cart-text]').text('Adding...');
      // formSelector.find('.qv-add-button span[data-loader]').removeClass('hide');
      jQuery.post('/cart/add.js', {
        quantity: qty,
        id: var_id
      },
        null,
        "json"
      ).done(function (itemData) {
        formSelector.find('.qv-add-button span[data-loader]').addClass('hide');
        formSelector.find('.qv-add-button span[data-add-to-cart-text]').text('Thank you');
        window.setTimeout(function(){
          formSelector.find('.qv-add-button span[data-add-to-cart-text]').text('Add to cart');
        }, 1000);
        // formSelector.find('.qv-add-to-cart-response').addClass('success').html('<span>' + product.title + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
        gtag_report_conversion('',itemData);
        Shopify.Cart.Update();
      })
      .fail(function ($xhr) {
          var data = $xhr.responseJSON;
          formSelector.find('.qv-add-button span[data-loader]').addClass('hide');
          formSelector.find('.qv-add-button span[data-add-to-cart-text]').text('Add to cart');
          // formSelector.find('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
        });
    }
    /*
    */
  });
};
$(document).ready(function () {
// Shopify.formatMoney(cart.total_price, settings.moneyFormat)
  quickView();
  // $('.product-index .product-info .product-title-wrap .prod-title').matchHeight();
});



Shopify.Cart = Shopify.Cart || {};

Shopify.Cart.Update = function () {
  $.getJSON('/cart.js', function (cart) {
    // console.log('cart count: ',cart.item_count)
    if(cart.item_count > 0){
      $('[data-cart-count-bubble]').removeClass('hide critical-hidden');
      $('[data-cart-count-bubble] [data-cart-count]').text(cart.item_count);
      $('.cart-count').removeClass('empty').text('('+cart.item_count+')');
    } else {
      $('[data-cart-count-bubble]').addClass('hide critical-hidden');
      $('[data-cart-count-bubble] [data-cart-count]').text(cart.item_count);
      $('.cart-count').addClass('empty').text('('+cart.item_count+')');
    }
  });
};